import { request } from "../../utils/APIUtils";

export function getOrderDetails(id: string, comprarGrupo: number) {
	return request({
		 path: `/campanha/publico/${id}/comprar?comprar_grupo=${comprarGrupo}`,
		 method: 'GET'
	});
}

export function getDadosPublicosCampanha(numero: string) {
	return request({
		 path: `/campanha/publico/${numero}`,
		 method: 'GET'
	});
}